import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type SearchParams = {
  id: string;
};

export const listDetailKey = (id: string) => ["get-list", id];

export const useGetList = (searchParams: SearchParams) => {
  const { apiClient } = useSalesyApiClient();

  const getList = async () => {
    return apiClient.lists.get({ id: searchParams.id });
  };

  return useQuery({
    queryKey: listDetailKey(searchParams.id),
    queryFn: getList,
    refetchInterval: (data) => {
      const list = data.state.data;
      if (!list || !list.enrichment_item_count) {
        return false;
      }

      if (list.enrichment_item_count.total_enrichment_items !== list.enrichment_item_count.enriched_enrichment_items) {
        return 800;
      }
      return false;
    },
  });
};
